<template>
  <div class="notfound">
    <h1>404 |Not Found</h1>
  </div>
</template>
<style scoped>
.notfound{
    font-size: 50px;
}
</style>